
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/claim/chessparty",
      function () {
        return require("private-next-pages/claim/chessparty.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/claim/chessparty"])
      });
    }
  